export default __webpack_public_path__ + "static/media/Logo-Animado.49e7789a.gif";